export default "__VITE_ASSET__d4b69a1b__"